import BaseModule from '@/store/baseModule';
import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import getInterventionsInfos from '@/services/services/interventions.service';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';

const attributesObj = {
  request_status: {
    serverSide: true,
    values: ['1'],
  },
  rejected: {
    serverSide: true,
    values: ['N'],
  },
  is_paused: {
    serverSide: true,
    values: ['N'],
  },
  his_treatment: {
    serverSide: true,
    values: [],
    type: '$is~PEM',
  },
};

const booleanFieldNames = [
  'work_order_group_qualif_nat',
  'work_order_group_type_nat',
];
const treatListResponse = treatsItems({
  booleanFieldNames,
});

export default (store) => {
  store.registerModule(
    ['requests', 'dispatched'],
    new BaseModule({
      attributesObj,
      sortChoices: ['creation_datetime'],
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.P2C_BASE_URI}/dispatched_requests`,
        }),
        treatListResponse,
      }),
      defaultSortBy: ['expiration'],
      makeQueryParams: makeListRequest({
        useEntities: true,
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    module: 'requests/dispatched',
    store,
  });

  basePlugin.loadItemsOnCurrentEntityChange();

  if (store.getters['boilerplate/isInit']) {
    store.dispatch('requests/dispatched/initItems');
  }

  const authHIS = [];
  if (store.getters[`${AUTHORIZATION_MODULE_PATH}/isPEM`]) {
    authHIS.push(true);
  }
  if (store.getters[`${AUTHORIZATION_MODULE_PATH}/isDispatcher`]) {
    authHIS.push(false);
  }
  store.commit('requests/dispatched/SET_ATTRIBUTES_OBJ', {
    ...store.getters['requests/dispatched/attributesObj'],
    his_treatment: {
      ...store.getters['requests/dispatched/attributesObj'].his_treatment,
      values: authHIS,
    },
  });

  basePlugin.persistVuexMutationsToLocalStorage(['SET_ATTRIBUTES_OBJ']);

  basePlugin.onItemsLoaded((items) => {
    getInterventionsInfos(items)
      .then(async (resultList) => {
        const newItems = items.map((item) => {
          const interventionItem = resultList.find(
            (intervention) => intervention.propertyId === item.property_id
          );
          return {
            ...item,
            interventions_in_progress: interventionItem
              ? interventionItem.list
              : [],
          };
        });
        store.commit('requests/dispatched/UPDATE_ITEMS', newItems);
      })
      .catch((err) => {
        store.dispatch('snackbar/setError', err);
      });
  });

  store.subscribeAction((action) => {
    if (action.type === 'requests/refreshItems') {
      store.dispatch('requests/dispatched/refreshItems');
    }
  });

  store.subscribeAction((action) => {
    if (
      action.type === 'requests/setFilterAttribute' &&
      action.payload.attribute === 'his_treatment'
    ) {
      store.dispatch(`requests/dispatched/setFilterAttribute`, action.payload);
    }
  });
};
